import type { SowWriteAccessUser } from '../../../services/api';

export interface SowUserSearchOption {
    userId: number;
    label: string;
    email: string | null;
    searchText: string;
}

export function buildSowUserSearchOptions(users: SowWriteAccessUser[]): SowUserSearchOption[] {
    return users
        .map((user) => {
            const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
            const label = name || user.email?.trim() || `User ${user.userId}`;
            const email = user.email?.trim() || null;
            return {
                userId: user.userId,
                label,
                email,
                searchText: `${label} ${email ?? ''} ${user.userId}`.trim(),
            };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
}

export function filterSowUserSearchOptions<T extends SowUserSearchOption>(
    options: T[],
    query: string,
): T[] {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) {
        return options;
    }
    return options.filter((option) => option.searchText.toLowerCase().includes(normalizedQuery));
}
